import { render } from "./ContactsPerson.vue?vue&type=template&id=7bf17578"
import script from "./ContactsPerson.vue?vue&type=script&lang=js"
export * from "./ContactsPerson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__